import {
  ThemeUICSSObject,
  getColorsAndStatesByPath,
  responsive,
  spacing,
} from '@apia/theme';

const breakMenu = 3;

export const imageTitleAndDescription: ThemeUICSSObject = {
  display: 'flex',
  alignItems: 'center',
  gap: spacing(5),
  width: responsive({ 0: '100%', 3: 'auto' }),

  'div.image': {
    display: responsive({ 0: 'none', 3: 'block' }),
    flexBasis: '60px',
    flexShrink: 0,
    width: '60px',
    height: '60px',

    img: {
      width: '60px',
      height: '60px',
    },
  },

  h1: {
    my: 0,
  },

  'div.titleAndDescription': {
    display: responsive({ 0: 'block', 3: 'flex' }),
    flexWrap: 'wrap',
    alignItems: responsive({ 0: 'center', 3: 'end' }),
    flexDirection: responsive({ 0: 'column', [breakMenu]: 'row' }),
    width: responsive({ 0: '100%', 3: 'auto' }),

    'h1, h2': {
      display: responsive({ 0: 'block', [breakMenu]: 'inline-block' }),
      width: 'auto',
      m: spacing(0),
    },

    '&:not(.entityTitle)': {
      h1: {
        '::after': {
          content: responsive({ 0: 'none', [breakMenu]: '">"' }),
          mr: responsive({ 0: 0, [breakMenu]: 5 }),
        },
      },
    },

    h2: {},
    p: {
      m: spacing(2),
      width: '100%',
    },
  },
};

export const header: ThemeUICSSObject = {
  display: 'flex',
  justifyContent: responsive({
    0: 'center',
    [breakMenu]: 'start',
    [breakMenu + 1]: 'space-between',
  }),
  alignItems: 'center',
  py: 0,
  my: 6,
  gap: responsive({ 0: 0, 2: 5 }),
  flexDirection: responsive({ 0: 'column-reverse', 2: 'row' }),
  top: responsive({ 0: 0, 4: 'auto' }),
  background: responsive({ 0: 'background', 4: 'transparent' }),
  textAlign: responsive({ 0: 'center', [breakMenu]: 'left' }),

  'div.imageTitleAndDescription': imageTitleAndDescription,

  '.iconsBar': {
    display: 'flex',
    width: 'max-content',
    justifyContent: 'end',
    flexShrink: 0,
    flexDirection: 'row',
    position: responsive({ 0: 'fixed', 4: 'initial' }),
    right: responsive({ 0: '8px', 4: 'auto' }),
    top: responsive({ 0: '36px', 2: '26px', 4: 'auto' }),

    border: 'none',
    padding: 'none',

    'button, a': {
      flexBasis: '50px',
      padding: responsive({ 0: 2, 4: 'none' }),
      flexShrink: 0,
      textAlign: 'center',
      width: '50px',
      height: '50px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      ...getColorsAndStatesByPath('buttons.primary', {
        states: {
          default: false,
        },
      }),
      backgroundColor: 'transparent',
      border: 'none',
      color: 'palette.text.primary',

      top: '20px',

      '&.toggleMenu': {
        display: responsive({ 0: 'flex', 4: 'none' }),
      },

      svg: {
        width: responsive({ 0: '20px', 5: '25px', 6: '27px' }),
        height: responsive({ 0: '20px', 5: '25px', 6: '27px' }),
        m: 'auto',
      },
    },

    '.favorite': {
      svg: {
        color: 'favorite',
        path: { fill: 'favorite' },
      },
    },
  },

  '&>div>h1': {
    my: 0,
  },

  '&>div > .description': {
    marginY: 0,
    marginTop: 2,
  },
};

const twoColumnsLayout: ThemeUICSSObject = {
  width: '100%',
  height: responsive({ 0: 'auto', 2: '100vh' }),
  position: 'static',
  bottom: responsive({ 0: 0, 2: 'auto' }),
  top: responsive({ 0: 0, 2: 'auto' }),
  display: 'flex',
  justifyContent: 'stretch',
  flexDirection: 'column',

  '.container': {
    width: '100%',
    maxWidth: responsive({ 0: '100%', 3: 'min(1550px, 100vw)' }),
    mx: 'auto',
  },

  '.containerScroll': {
    width: '100%',
  },

  '.twoColumnsLayout__header': { ...header, mx: 3 },

  '.notificationsView': {
    my: 0,
    px: 3,
    width: responsive({ 0: '100%', 3: 'calc(100% - 61px)', 4: '100%' }),

    '& > .notification': {
      width: '100%',
    },
  },

  '& .twoColumnsContent': {
    flexGrow: 2,
    flexShrink: 2,
    display: 'grid',
    flexDirection: 'column-reverse',
    pb: '60px',
    gap: spacing(3),
    gridTemplateColumns: responsive({
      0: '1fr',
      4: '1fr 350px',
      5: '1fr 375px',
      6: '1fr 400px',
    }),

    position: 'sticky',

    main: {
      paddingLeft: responsive({ 0: 0, 1: 3 }),
      paddingRight: responsive({ 0: 0, 1: 3, 4: 0 }),

      display: responsive({ 0: 'flex', 3: 'block' }),
      flexDirection: 'column',
      gap: spacing(4),
    },
  },

  '& > .spacer': {
    height: responsive({ 0: '0px', 4: '2em' }),
  },

  '.showResponsive': {
    display: responsive({ 0: 'block', 3: 'none' }),
  },
};

export default twoColumnsLayout;
